import http, { createApi } from '@core/fetch'
import { getWebSocketUrl } from '@util'

const ws_url = getWebSocketUrl().domain

export default {
  getCustomerList: body =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/List', { body }), // 客资列表
  getStaffList: () => http('/p/wedding/Admin/APIMerchantSupport/ListAll'), //获取客服（归属人）列表
  getCustomerDetail: body =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/Detail', { body }), // 客资详情
  finish: body =>
    http.post('/p/wedding/Admin/APICrmMerchantCustomer/Finish', { body }), // 确认完成服务
  changeMerchant: body =>
    http.post('/p/wedding/Admin/APICrmMerchantCustomer/ChangeMerchantSupport', {
      body
    }), //移交给他人
  createCustomer: body =>
    http.post('/p/wedding/Admin/APICrmMerchantCustomer/Create', { body }), //录入客资
  createFollowUp: body =>
    http.post('/p/wedding/Admin/APICrmMerchantCustomer/FollowUp', { body }), // 创建跟进记录
  getPropertyList: () =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/AllPropertiesList'), //获取加盟店所有品类
  getSearchList: body =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/SearchSetMealList', { body }), //签单商品列表
  createSign: body =>
    http.post('/p/wedding/Admin/APICrmMerchantCustomer/Signing', { body }), //发起签单
  getCardList: body =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/RecordList', { body }), // 跟进记录列表
  getBudget: body =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/Budget', { body }), // 分配预算金额
  searchPhone: body =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/SearchPhone', { body }), //手机号查重
  modifyCustomer: body =>
    http.post('/p/wedding/Admin/APICrmMerchantCustomer/Modify', { body }), // 编辑客资
  getSupportList: body =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/SupportList', { body }), // 移交他人-归属人和在线客服列表、当前客户私信处理人
  changeChat: (id, body) => {
    return http.put(`${ws_url}/api/channels/${id}`, {
      body
    }) //私信转移
  },

  /* 调查问卷信息 */
  surveyInfo: body =>
    http('/p/wedding/Admin/APICrmMerchantCustomer/surveyInfo', { body }),
  /* 客子来源列表 */
  sourceList: () => http('/p/wedding/Admin/APICrmMerchantCustomer/sourceList'),
  /* 批量导入 */
  batchImport: body =>
    http.post('/p/wedding/Admin/APICrmMerchantCustomer/BatchImport'),
  // 发起任务
  createTask: createApi.post(
    '/p/wedding/Admin/APICrmMerchantCustomer/createTask'
  ),
  // 发起联系
  createContact: createApi.post(
    '/p/wedding/Admin/APICrmMerchantCustomer/contact'
  ),
  // 添加协作人
  addSupport: createApi.post(
    '/p/wedding/Admin/APICrmMerchantCustomer/saveRelation'
  ),
  // 不再跟进
  setFollowStatus: createApi.post(
    '/p/wedding/Admin/APICrmMerchantCustomer/setFollowStatus'
  ),
  // 按月导出客资
  exportCustomerByMonth: createApi(
    '/p/wedding/Admin/APICrmMerchantCustomer/export'
  ),
  // 派单
  customerToLeads: createApi(
    '/p/wedding/Admin/APIMerchantCustomer/CustomerToLeads'
  ),
  // 补单扣款
  createOrder: createApi.post(
    '/p/wedding/Admin/APICrmMerchantCustomer/CreateOrder'
  ),
  // 已派商家列表
  orderMerchant: createApi(
    '/p/wedding/Admin/APICrmMerchantCustomer/OrderMerchant'
  )
}
